import { Navigate, Route, Routes } from 'react-router-dom';
import Register from './pages/authentication/Register';
import Login from './pages/authentication/Login';
import { ColorSchemeProvider, MantineProvider, rem } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ProtectedRoute from './router/protected-route';
import routes from './router/routes';

function App() {
  const { darkMode } = useSelector(state => state.settings);

  const [colorScheme, setColorScheme] = useState('light');

  useEffect(() => {
    if (darkMode) {
      setColorScheme('dark');
    } else {
      setColorScheme('light');
    }
  }, [darkMode]);

  const renderRoutes = () =>
    routes
      .map(route => {
        const routesList = [];
        routesList.push(renderRoute(route));
        if (route.children) {
          route.children.forEach(child => {
            routesList.push(renderRoute(child));
          });
        }
        return routesList;
      })
      .flat();

  const renderRoute = route => {
    return <Route key={route.key} path={route.route} element={route.component} />;
  };

  const toggleColorScheme = value => setColorScheme(value || (colorScheme === 'dark' ? 'light' : 'dark'));
  return (
    <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
      <MantineProvider
        withGlobalStyles
        withNormalizeCSS
        theme={{
          colorScheme,
          loader: 'bars',
          globalStyles: theme => ({
            '*, *::before, *::after': {
              boxSizing: 'border-box',
            },

            body: {
              ...theme.fn.fontStyles(),
              backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : '#F8F9FA',
              color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,
              lineHeight: theme.lineHeight,
            },

            '.your-class': {
              backgroundColor: 'red',
            },

            '#your-id > [data-active]': {
              backgroundColor: 'pink',
            },

            '.pageTitle': {
              color: theme.colorScheme === 'dark' ? theme.white : theme.black,
              fontFamily: `Greycliff CF, ${theme.fontFamily}`,
              fontSize: rem(30),
              lineHeight: 1.2,
              fontWeight: 700,

              [theme.fn.smallerThan('xs')]: {
                fontSize: rem(18),
              },
            },
          }),
          other: {
            pageTitle: theme => ({
              color: theme.colorScheme === 'dark' ? theme.white : theme.black,
              fontFamily: `Greycliff CF, ${theme.fontFamily}`,
              fontSize: rem(44),
              lineHeight: 1.2,
              fontWeight: 700,

              [theme.fn.smallerThan('xs')]: {
                fontSize: rem(26),
              },
            }),
          },
        }}
      >
        <Routes>
          {/* Protected routes */}
          <Route element={<ProtectedRoute allowedRoles={['user', 'admin']} />}>{renderRoutes()}</Route>

          {/* Public routes */}
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />

          {/* Default route */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </MantineProvider>
    </ColorSchemeProvider>
  );
}

export default App;
